import * as React from 'react'
import { DataGrid } from '@mui/x-data-grid'
import {
  Box,
  Button,
  Chip,
  IconButton,
  Link,
  MenuItem,
  Paper,
  Select,
  Skeleton,
  Typography,
} from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
import { BackArrowIcon, GoToLiveIcon, } from '../../icons'
import { GlobalStyles } from '@mui/material'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import UniversitySummary from '../university-table/UniversitySummary'
// import universityReviewRows from './UniversityData/data'
import UserCommentModal from './CommentModal/UserCommentModal'
import ActionDropdown from './ActionDropdown'
import { fetchUniversitiesNames, fetchUniversityDashboardStats, fetchUniversityList } from '../../api/universityApi'
import { updateStatus } from '../../api/adminApi'
import { handlePreview } from '../CourseDetails/CourseDetailsForm'
import { useDispatch } from 'react-redux'
import { setPaginationFiled } from '../../containers/pagination-container/reducer/paginationSlice'
import { useSelector } from 'react-redux'
import CommonTableFormat from '../common/CommonTableFormat'
import CommonFilterTab from '../common/CommonFilterTab'
import { setFilterField } from '../../containers/filter-container/reducer/filterSlice'
import { defaultPaginationValues, filterTypeOptions, studentStatusList } from '../../utils/constant'
import { formatMultiQueryParams, jsonParserFormatter } from '../../utils/helperFunction'
import CommonDataTable from '../common/CommonDataTable'

const UniversityReview = ({ isHeadHide = true, activeTab = 0, module, type }) => {
  const filterSlice = useSelector(state => state.filter?.filters)
  const LOCATION_FILTER = `filters_${activeTab}:${window.location.pathname}`
  const dispatch = useDispatch()
  const [rows, setRows] = React.useState([])
  const [loading, setLoading] = React.useState(true)
  const navigate = useNavigate()
  const location = useLocation()
  const [selectedStatus, setSelectedStatus] = React.useState('')
  const [openCommentModal, setOpenCommentModal] = React.useState(false)
  const [commentText, setCommentText] = React.useState('')
  const [selectedRowId, setSelectedRowId] = React.useState(null)
  const [rowCount, setRowCount] = React.useState(0);
  const [searchFilter, setSearchFilter] = React.useState({})
  const [pageFilters, setPageFilters] = React.useState(defaultPaginationValues);
  const [isRender, setIsRender] = React.useState(false)
  const [universitySuggestion, setUniversitySuggesion] = React.useState([])

  const handleFliterSliceChange = (values = {}, isReset = false) => {
    let isQuery = typeof values === "object" && Object.keys(values)?.length
    isQuery && dispatch(setFilterField({ pathname: LOCATION_FILTER, filters: JSON.stringify({ ...(isReset ? {} : pageFilters), ...defaultPaginationValues, ...values }) }))
  }

  const handleSaveComment = () => {
    handleChangeStatus(selectedRowId, "university", "Rework", commentText);
    setOpenCommentModal(false);
    setCommentText('');
  };

  React.useEffect(() => {
    setLoading(true)
    const multiFilter = formatMultiQueryParams(filterSlice[LOCATION_FILTER])
    fetchUniversityList(setRows, { ...searchFilter, ...multiFilter, isMultiFilter: true }, false, true, setRowCount)
      .finally(() => setLoading(false))
  }, [filterSlice[LOCATION_FILTER], isRender])

  // handle extra filter tabs changes
  React.useEffect(() => {
    if (pageFilters?.page) {
      handleFliterSliceChange({ page: 0 })
    } else {
      setIsRender(!isRender)
    }
  }, [searchFilter])

  // parse page filters
  React.useEffect(() => {
    const values = jsonParserFormatter(filterSlice[LOCATION_FILTER])
    setPageFilters(values)
  }, [filterSlice[LOCATION_FILTER]])

  // load course/ universities for filter suggestions
  React.useEffect(() => {
    fetchUniversitiesNames((result) => setUniversitySuggesion(result?.map(item => ({ ...item, value: item?.label }))))
      .catch(err => console.log("error:---", err))
  }, [])


  const handleChangeStatus = async (rowId, type, action, reason = "", event) => {
    if (action === "Approve") {
      try {
        const res = await updateStatus({ id: rowId, status: "approved", type: "university" });
        setIsRender(!isRender)
      } catch (err) {
        console.log('err', err)
      }
    }
    if (action === "Rework") {
      try {
        const res = await updateStatus({ id: rowId, status: "rework", reason, type: "university" });
        setIsRender(!isRender)
      } catch (err) {
        console.log('err', err)
      }
    }
    if (action === 'View') {
      const universityId = rows.find(r => r.id === rowId)?.universityId || '';
      const url = `/university-listing-management/university-details/${universityId}`
      if (event?.ctrlKey || event?.metaKey) {
        window.open(url, '_blank')
      } else {
        navigate(url, {
          state: { viewOnly: true, source: 'ActionMenu', backUrl: location?.pathname, activeTab: activeTab }
        });
      }
      return;
    }
  };


  function getStatusClass(status) {
    switch (status) {
      case 'Pending':
        return 'status-pending'
      case 'Approved':
        return 'status-live'
      case 'Re-Sumbited':
        return 'status-draft'
      case 'Send for Rework':
        return 'status-draft'
      case 'Draft':
        return 'status-deactivated'
      default:
        return ''
    }
  }



  const columns = [
    {
      field: 'sNo',
      headerName: 'S. No.',
      width: 60,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      // renderCell: (params) => {
      //   return (
      //     rows?.findIndex((r) => r.id === params.row.id) + 1
      //   )
      // },
    },
    { field: 'universityId', 
      headerName: 'University ID', 
      width: 130, 
      cellClassName: 'sticky-col-1', 
      headerClassName: 'sticky-col-1',
      filterColumnName: "universityId",
      filterType: filterTypeOptions.string,
     },
    {
      field: 'name',
      headerName: 'University',
      width: 220,
      flex: 2,
      filterColumnName: "universityName",
      filterType: filterTypeOptions.selection,
      selection:universitySuggestion,
      renderCell: (params) =>
        loading ? (
          <Skeleton width={150} />
        ) : (
          <Box display="flex" alignItems="center" gap={1}>
            <Box
              component="img"
              src={params.row.logo}
              alt="logo"
              sx={{
                width: 40,
                height: 40,
                padding: '5px',
                borderRadius: '50%',
                objectFit: 'contain',
                backgroundColor: '#fff',
                boxShadow: '0 1px 4px rgba(0, 0, 0, 0.15)',
                display: 'block',
                maxHeight: 60,
              }}
            />
            {params.value}
          </Box>
        ),
    },
    {
      field: 'gotoLive',
      headerName: (selectedStatus === 'Pending' || selectedStatus === 'Draft') ? 'Preview' : 'Preview',
      width: 100,
      flex: 1,
      filterable:false,
      renderCell: (params) =>
        loading ? (
          <Skeleton variant="circular" width={24} height={24} />
        ) : (
          <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', height: '100%' }}>
            <IconButton color="primary"
              onClick={() => handlePreview(params?.row?.id, 'university')}
            >
              <GoToLiveIcon />
            </IconButton>
          </Box>
        ),
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
      minWidth: 150,
      filterColumnName: "status",
      filterType: filterTypeOptions.selection,
      selection:studentStatusList,
      renderCell: (params) =>
        loading ? (
          <Skeleton width={70} />
        ) : (
          <Chip
            label={params.value}
            size="small"
            icon={
              <FiberManualRecordIcon
                className={getStatusClass(params.value)}
                sx={{
                  fontSize: 10,
                  color: getStatusColor(params.value),
                }}
              />
            }
            sx={{
              bgcolor: getStatusBgColor(params.value),
              color: getStatusTextColor(params.value),
              fontWeight: 500,
            }}
          />
        ),
    },

    { field: 'createdDate', 
      headerName: 'Created Date',
       width: 130,
      filterColumnName: "createdAt",
      filterType: filterTypeOptions.dateRange,
       },
    { field: 'lastUpdate',
       headerName: 'Last Update', 
       width: 130,
      filterColumnName: "updatedAt",
      filterType: filterTypeOptions.dateRange,
       },
    {
      field: 'completion',
      headerName: 'Completion',
      flex: 1,
      width: 100,
      filterColumnName: "completionPercentage",
      filterType: filterTypeOptions.numberRange,
      renderCell: (params) => (
        <Box
          sx={{
            color: params.value >= 80 ? '#22c55e' : params.value >= 50 ? '#f59e0b' : '#098B34',
            fontWeight: 500,
            fontSize: '13px',
          }}
        >
          {params.value}%
        </Box>
      ),
    },
    {
      field: 'createdBy',
      headerName: 'Created By',
      flex: 1,
      width: 140,
      filterColumnName: "createdBy",
      filterType: filterTypeOptions.string,
      renderCell: (params) =>
        loading ? <Skeleton width={80} /> : params.value,
    },
    {
      field: 'reviewedBy',
      headerName: 'Reviewed By',
      flex: 1,
      minWidth: 130,
      filterColumnName: "reviewedBy",
      filterType: filterTypeOptions.string,
    },
    {
      field: 'action',
      headerName: 'Action',
      flex: 1,
      width: 140,
      filterable:false,
      renderCell: (params) =>
        loading ? <Skeleton width={80} /> : <ActionDropdown
          rowId={params.row.id}
          onAction={handleChangeStatus}
          onRejectClick={() => {
            setSelectedRowId(params.row.id)
            setCommentText('')
            setOpenCommentModal(true)
          }}
          status={params?.row?.status}
        />,
    },

  ]



  function getStatusBgColor(status) {
    switch (status) {
      case 'Live':
        return '#fff'
      case 'Draft':
        return '#fff'
      case 'Pending':
        return '#fff'
      case 'Deactivated':
        return '#fff'
      default:
        return '#fff'
    }
  }

  function getStatusTextColor(status) {
    switch (status) {
      case 'Approved':
        return '#363853' // darker green
      case 'Re-Sumbited':
        return '#363853' // darker gray
      case 'Pending':
        return '#363853' // darker orange
      case 'Send for Rework':
        return '#363853' // darker red
      default:
        return '#666'
    }
  }

  // Helper functions for status colors
  function getStatusColor(status) {
    switch (status) {
      case 'Approved':
        return '#22c55e' // green
      case 'Re-Sumbited':
        return '#64748b' // grayish
      case 'Pending':
        return '#f97316' // orange
      case 'Send for Rework':
        return '#ef4444' // red
      default:
        return '#999'
    }
  }

  return (
    <>

      <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
        {isHeadHide && (<div className="page-header" style={{ position: 'sticky', top: '4.5rem', zIndex: '9', padding: '10px 15px', borderBottom: '1px solid #E6E7E8', background: '#fff', }}>
          <div className="row align-items-center">
            <div className="col">
              <Typography sx={{ fontSize: '18px', fontWeight: '600', color: '#15243E', display: 'flex', alignItems: 'center', gap: 1, }}><Link href="/" className='d-flex'><BackArrowIcon /></Link>University Listing Management </Typography>
            </div>
            {/* End Col */}
            <div className="col">  <Box display="flex" gap={2} sx={{ justifyContent: 'end', }}>

              <Button onClick={() => navigate('/university-listing-management/university-details')} sx={{ background: '#0463EF', color: '#fff', minHeight: 'auto', padding: '4px 15px', fontSize: '14px', textTransform: 'capitalize', }}>
                Add University
              </Button>
            </Box></div>
          </div>
          {/* End Col */}
        </div>)}
        <UniversitySummary type="university" isAdmin={false} isRender={isRender}/>
        {/* Filter Toolbar */}
        <CommonFilterTab type='university' module='reviewer' searchPlaceholder='Search university name...' detailType='University Details' fetchList={setSearchFilter} showCount={rows?.length} rowCount={rowCount} isStatus={true} />

        {/* Data Table */}
        <CommonDataTable columns={columns} rows={rows} idKey="field" loading={loading} filterEnabled={true} rowCount={rowCount}
          pageFilters={pageFilters}
          handleFliterSliceChange={handleFliterSliceChange}
          otherPath={activeTab}
        />

      </Box>

      <UserCommentModal
        open={openCommentModal}
        onClose={() => setOpenCommentModal(false)}
        onSave={handleSaveComment}
        commentText={commentText}
        setCommentText={setCommentText}
      />


    </>
  )
}

export default UniversityReview
